import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { GET_MEMBER_FILTER_CONTACT_GROUP_API, POST_MEMBER_FILTER_CONTACT_GROUP_API, DELETE_MEMBER_FILTER_CONTACT_GROUP_API, POST_MEMBER_FILTER_CONTACT_GROUP_ITEM_API } from "@apis/apiPath";

const useMemberFilterContactGroupApi = () => {
	const Ajax = useAjax();

	const getMemberFilterContactGroup = useCallback(
		async filterType => {
			return await Ajax.get(GET_MEMBER_FILTER_CONTACT_GROUP_API(filterType));
		},
		// eslint-disable-next-line
		[]
	);

	const postMemberFilterContactGroup = useCallback(
		async (filterType, params) => {
			return await Ajax.post(POST_MEMBER_FILTER_CONTACT_GROUP_API(filterType), params);
		},
		// eslint-disable-next-line
		[]
	);

	const deleteMemberFilterContactGroup = useCallback(
		async (filterType, filterID) => {
			return await Ajax.delete(DELETE_MEMBER_FILTER_CONTACT_GROUP_API(filterType, filterID));
		},
		// eslint-disable-next-line
		[]
	);

	const postMemberFilterContactGroupItem = useCallback(
		async (filterType, params) => {
			return await Ajax.post(POST_MEMBER_FILTER_CONTACT_GROUP_ITEM_API(filterType), params);
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getMemberFilterContactGroup,
		postMemberFilterContactGroup,
		deleteMemberFilterContactGroup,
		postMemberFilterContactGroupItem,
	};
};

export default useMemberFilterContactGroupApi;
